import QueryString from 'query-string';
import { SubscriptionType } from 'common/constants/subscription';
import { SubscriptionsConfig } from 'common/constants/subscription-config';
import { store } from '../../store';

const APP_HOST_ID = 'account';
const LOCALHOST_DOMAIN = 'test.skema.site';
const BaseDomainRegex = new RegExp(`(${APP_HOST_ID})\\.(?<domain>.*)`);

const getRedirectParams = (): { type: SubscriptionType, redirectUrl?: string } => {
  try {
    const { location } = store.getState().router;
    const { returnUrl, type } = QueryString.parse(location.search);
    return { type: type || SubscriptionType.Modular, redirectUrl: returnUrl };
  } catch (_e) {
    return { type: SubscriptionType.Modular, redirectUrl: null };
  }
};

const getBaseHost = (): string => {
  return !location.host.startsWith('localhost')
    ? location.host.match(BaseDomainRegex).groups.domain
    : LOCALHOST_DOMAIN;
};

const getRedirectHost = (type: SubscriptionType): string => {
  const subscriptionConfig = SubscriptionsConfig[type];
  const prefix = subscriptionConfig && subscriptionConfig.prefix;

  return prefix
    ? `${location.protocol}//${prefix}.${getBaseHost()}`
    : null;
};

const getAppRedirectUrl = (type: SubscriptionType = SubscriptionType.Modular, redirectUrl?: string): string => {
  const redirectHost = getRedirectHost(type);
  if (!redirectHost) {
    return null;
  }

  return redirectUrl
    ? `${redirectHost}${redirectUrl}`
    : redirectHost;
};

const ACCOUNT_PREFIX = 'account';

const getAccountRedirectUrl = (redirectUrl?: string): string => {
  if (!redirectUrl) {
    return null;
  }

  const cleanRedirectUrl = redirectUrl.startsWith(ACCOUNT_PREFIX)
    ? redirectUrl.substring(ACCOUNT_PREFIX.length + 1)
    : redirectUrl;

  return `${location.protocol}//${ACCOUNT_PREFIX}.${getBaseHost()}/${cleanRedirectUrl}`;
};

const getRedirectUrl = (type: SubscriptionType, redirectUrl?: string): string => {
  if (redirectUrl?.startsWith(ACCOUNT_PREFIX)) {
    return getAccountRedirectUrl(redirectUrl);
  }

  return getAppRedirectUrl(type, redirectUrl);
};

const redirectTo = (type: SubscriptionType, redirectUrl?: string): void => {
  const url = getRedirectUrl(type, redirectUrl);
  if (!url) {
    return;
  }

  window.location.replace(url);
};

const redirectToQueryParamsUrl = (): void => {
  const { type, redirectUrl } = getRedirectParams();
  redirectTo(type, redirectUrl);
};

const getRedirectUrlFromQueryParamsUrl = (): string => {
  const { type, redirectUrl } = getRedirectParams();
  return getRedirectUrl(type, redirectUrl);
};

export const RedirectUrlUtils = {
  getRedirectUrl,
  redirectTo,
  redirectToQueryParamsUrl,
  getRedirectUrlFromQueryParamsUrl,
  getAppRedirectUrl,
  getAccountRedirectUrl,
};
